(function(requirejs) {

    // Commons dependencies built into one file.
    var baseLibsPath = '../';
    var baseJQueryPath = baseLibsPath + 'jquery/';
    var baseCodeMirrorPath = baseLibsPath + 'codemirror/5.38.0/';
    var gMapClient = googleMapClient && googleMapClient.trim().length > 0 ? "channel=portal-js&client=" + googleMapClient + "&" : "";
    var gMapKey = googleMapKey && googleMapKey.trim().length > 0 ? "key=" + googleMapKey + "&" : "";
    var clientOrKey = gMapClient.trim().length == 0 ? gMapKey : gMapClient;
    var conf = {
        baseUrl: '/resources/amd',
        // TODO do not forget to add all the third party libs in the build.template
        paths: {
            'jquery': baseJQueryPath + 'core/2.1.4/jquery-2.1.4.min',
            'jquery-cookie': baseJQueryPath + 'plugin/jquery-cookie/1.4.1/jquery.cookie-1.4.1.min',
            'jquery.ui': baseJQueryPath + 'ui/1.11.4/jquery-ui.min',
            'jquery.fancytree': baseJQueryPath + 'plugin/fancytree/2.10.1/jquery.fancytree-all.min',
            'jquery-ui-timepicker-addon': baseJQueryPath + 'plugin/timepicker/1.5.5/jquery-ui-timepicker-addon',
            'timeline': baseLibsPath + 'timeline/2.9.1/timeline-min',
            'dygraph': baseLibsPath + 'dygraph/1.1.0/dygraph-combined',
            'd3js': baseLibsPath + 'd3js/3.5.5/d3.min',
            // @see DynamicResourcesController
            'tap-messages': '/utils/js/tap/dictionary',
            'google-maps': 'https://maps.googleapis.com/maps/api/js?' + clientOrKey + 'v=3.34&libraries=places,drawing,geometry',
            'marker-clusterer': baseLibsPath + 'marker-clusterer-plus/2.1.11/markerclusterer',
            'async': baseLibsPath + 'requirejs-plugins/1.0.3/async',
            'ion-range-slider': baseJQueryPath + 'plugin/range-slider/2.0.10/js/ion-rangeSlider/ion.rangeSlider.min',
            'jquery-multi-select': baseJQueryPath + 'plugin/multiselect/0.9.12/js/jquery.multi-select',
            'chosen': baseJQueryPath + 'plugin/chosen/1.8.7/chosen.jquery.min',
            'selectize': baseJQueryPath + 'plugin/selectize/0.12.6/selectize.min',
            'jquery-deserialize' : baseJQueryPath + 'plugin/jquery-deserialize/1.3.3/jquery.deserialize', 
            'formatDateTime': baseJQueryPath + 'plugin/formatDateTime/1.1.6/jquery.formatDateTime.min',
            'introjs' : baseLibsPath + 'introjs/1.0.0/intro.min',
            'algolia' : 'https://cdn.jsdelivr.net/algoliasearch/3/algoliasearch.min',
            'autocomplete' : 'https://cdn.jsdelivr.net/autocomplete.js/0/autocomplete.min',
            'parse-dms': baseLibsPath + 'parseDMS/0.0.3/index',
            'codemirror': baseCodeMirrorPath + 'lib/codemirror.min',
            'codemirror-show-hint': baseCodeMirrorPath + 'addon/hint/show-hint.min',
            'codemirror-lint': baseCodeMirrorPath + 'addon/lint/lint.min',
            'codemirror-json-lint': baseCodeMirrorPath + 'addon/lint/json-lint.min',
            'jsonlint': baseLibsPath + 'jsonlint/1.6.0/jsonlint.min',
            'resumable': baseLibsPath + 'resumable/1.0.0/resumable',
            'MeasureTool': baseLibsPath + 'measure-tool/0.4.2/measureTool.min'
        },
        map: {
        	'*': {
        		'../../lib/codemirror': 'codemirror'
        	}
        },
        shim: {
            'timeline': {
                exports: 'links.Timeline'
            },
            'marker-clusterer': {
                deps: ['async!google-maps'],
                exports: 'MarkerClusterer'
            },
            'ion-range-slider': {
                deps: ['jquery'],
                exports: '$.fn.ionRangeSlider'
            },
            'jquery-multi-select': {
                deps: ['jquery'],
                exports: '$.fn.multiSelect'
            },
            'chosen': {
                deps: ['jquery'],
                exports: '$.fn.chosen'
            },
            'parse-dms': {
                exports : 'parseDMS'
            },
            'resumable': {
                        deps: ['jquery'],
                exports: 'Resumable'
            }
        }
    };
    requirejs.config(conf);
})(require);

define("config", function(){});

